/* eslint-disable @typescript-eslint/no-unused-vars */
import { FormEvent, useState } from 'react'
import { toast } from 'react-toastify'
import { useAppDispatch, useAppSelector } from '../../hooks'
import { addNewAccount, RobloxAccountAuthType } from '../../services/robloxAccounts'
import { robloxAccountsActions } from '../../store/slices/robloxAccountsSlice'
import { uiActions } from '../../store/slices/uiSlice'
import Modal from '../Modal/Modal'
import ProxySelectModal from '../ProxySelectModal'
import SaveProxyModal from '../SaveProxyModal'
import ProxyManageModal from '../ProxyManageModal'

import { Header, Input } from '../ui'
import { Form, InputFields, ProxyHelper, Submit, TypeButton, TypeButtonsWrapper, ProxyFieldContainer } from './styles'
import ProxyActions from '../ProxyActions'

const AddAccountModal = () => {
	const isOpen = useAppSelector((state) => state.ui.addAccountModalIsOpen)
	const [login, setLogin] = useState<string>('')
	const [password, setPassword] = useState<string>('')
	const [cookie, setCookie] = useState<string>('')
	const [proxy, setProxy] = useState('')
	const [isSelectModalOpen, setIsSelectModalOpen] = useState(false)
	const [isSaveModalOpen, setIsSaveModalOpen] = useState(false)
	const [isManageModalOpen, setIsManageModalOpen] = useState(false)

	const dispatch = useAppDispatch()

	const closeHandler = () => {
		dispatch(uiActions.setAddAccountModallState(false))
		setLogin('')
		setPassword('')
		setCookie('')
		setProxy('')
		setIsSelectModalOpen(false)
		setIsSaveModalOpen(false)
		setIsManageModalOpen(false)
	}

	const handleSelectProxy = () => {
		setIsSelectModalOpen(true)
	}

	const handleProxySelected = (selectedProxy: string) => {
		setProxy(selectedProxy)
		setIsSelectModalOpen(false)
	}

	const handleManageProxies = () => {
		setIsManageModalOpen(true)
	}

	const handleSaveCurrentProxy = () => {
		setIsSaveModalOpen(true)
	}

	const submitHandler = async (e: FormEvent<HTMLButtonElement>) => {
		e.preventDefault()
		const addPromise = addNewAccount({
			authType: RobloxAccountAuthType.Cookie,
			cookie,
			login,
			password,
			proxy,
		})
		toast.promise(addPromise, {
			pending: 'Checking your account',
			success: {
				render: () => {
					closeHandler()
					dispatch(robloxAccountsActions.fetchActiveAccounts())
					return 'Account added'
				},
			},
			error: {
				render: (e) => e.data.response.data.message || 'Error',
			},
		})
	}

	if (!isOpen) {
		return <></>
	}

	return (
		<Modal close={closeHandler}>
			<Header>Add an account</Header>
			<Form>
				<InputFields>
					<Input
						key='cookie'
						id='cookie'
						label='Cookie'
						value={cookie}
						onChange={(e) => setCookie(e.target.value)}
					/>
				</InputFields>
				<ProxyHelper>You can add format proxy: login:pass@1.1.1.1:333</ProxyHelper>
				<InputFields>
					<ProxyFieldContainer>
						<Input
							key='proxy'
							id='proxy'
							label='Proxy'
							value={proxy}
							onChange={(e) => setProxy(e.target.value)}
						/>
						<ProxyActions 
							currentProxy={proxy}
							onSelectProxy={handleSelectProxy}
							onManageProxies={handleManageProxies}
							onSaveCurrentProxy={handleSaveCurrentProxy}
						/>
					</ProxyFieldContainer>
				</InputFields>
				<Submit onClick={submitHandler}>Add</Submit>
			</Form>
			
			<ProxySelectModal
				isOpen={isSelectModalOpen}
				onClose={() => setIsSelectModalOpen(false)}
				onSelect={handleProxySelected}
			/>
			
			<SaveProxyModal
				isOpen={isSaveModalOpen}
				onClose={() => setIsSaveModalOpen(false)}
				currentProxy={proxy}
			/>
			
			<ProxyManageModal
				isOpen={isManageModalOpen}
				onClose={() => setIsManageModalOpen(false)}
			/>
		</Modal>
	)
}

export default AddAccountModal
